import React, {useState, useEffect} from 'react';


function NumberChartComponent(props){
    const [statistics, setStatistics] = useState({
       count: 0,
       min : 0,
       max : 0,
       mean : 0,
       median : 0,
       variance : 0,
       standard_deviation: 0,
       mode: 0
    });


    useEffect(() => {
        const statistics = {
            count: props.questionAnswers?.count,
            min : props.questionAnswers?.min,
            max : props.questionAnswers?.max,
            mean : props.questionAnswers?.mean,
            median : props.questionAnswers?.median,
            variance : props.questionAnswers?.variance,
            mode : props.questionAnswers?.mode.join(","),
            standard_deviation : props.questionAnswers?.standard_deviation
        };
        setStatistics(statistics);
    }, [props.questionAnswers]);

    useEffect(() => {
        const chartNode = document.getElementById("reports_container_content_" + props.questionData.question.question_id);
        let chartInfo = {
            chartText: props.questionData.question.id + ". " + props.questionData.question.question,
            numAnswers: statistics.count,
            chart: chartNode
        };
        props.updateChartInfo && props.updateChartInfo(props.chartIndex, chartInfo);
    }, [statistics]);

    return(
        <React.Fragment>
            <div className="questionaire__reports__container__content__table" id={"reports_container_content_" + props.questionData.question.question_id}>
                <div
                    className="questionaire__reports__container__content__table__row questionaire__reports__container__content__table__row--head">
                    <span>STATS</span>
                    <span>VALUES</span>
                </div>
                <div className="questionaire__reports__container__content__table__row">
                    <span>Count</span>
                    <span>{statistics.count === 0 ? "-": parseFloat(statistics.count).toFixed(2)}</span>
                </div>
                <div className="questionaire__reports__container__content__table__row">
                    <span>Min</span>
                    <span>{statistics.min === 0 ? "-" : parseFloat(statistics.min).toFixed(2)}</span>
                </div>
                <div className="questionaire__reports__container__content__table__row">
                    <span>Max</span>
                    <span>{statistics.max === 0 ? "-" : parseFloat(statistics.max).toFixed(2)}</span>
                </div>
                <div className="questionaire__reports__container__content__table__row">
                    <span>Mean</span>
                    <span>{statistics.mean === 0 ? "-" : parseFloat(statistics.mean).toFixed(2)}</span>
                </div>
                <div className="questionaire__reports__container__content__table__row">
                    <span>Median</span>
                    <span>{statistics.median === 0 ? "-" : parseFloat(statistics.median).toFixed(2)}</span>
                </div>
                <div className="questionaire__reports__container__content__table__row">
                    <span>Variance</span>
                    <span>{statistics.variance === 0 ? "-" : parseFloat(statistics.variance).toFixed(2)}</span>
                </div>
                <div className="questionaire__reports__container__content__table__row">
                    <span>Mode</span>
                    <span>{statistics.mode === "" ? "-" : statistics.mode}</span>
                </div>
                <div className="questionaire__reports__container__content__table__row">
                    <span>Standard Deviation</span>
                    <span>{statistics.standard_deviation === 0 ? "-" : parseFloat(statistics.standard_deviation).toFixed(2)}</span>
                </div>
            </div>
        </React.Fragment>);
}

export default NumberChartComponent;